var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanetRinged(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M502.89 9.077C479.387 -14.426 414.629 9.077 335.744 63.834C260.234 32.58 170.222 47.582 108.84 108.84C47.582 170.222 32.58 260.234 63.834 335.744C9.077 414.629 -14.426 479.387 9.077 502.89C46.206 540.145 186.975 459.76 323.367 323.367S540.145 46.206 502.89 9.077ZM346.495 346.495C308.365 384.625 262.359 425.38 215.728 460.135C283.862 473.511 354.121 452.134 403.127 403.002C452.134 353.996 473.511 283.612 460.01 215.603C423.88 264.234 382.125 310.865 346.495 346.495Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanetRinged);
export default __webpack_public_path__ + "static/media/planet-ringed.622dbe8549325543ed6ae373f24c27c0.svg";
export { ForwardRef as ReactComponent };